import { decodeJwt } from './accessRight';
import { getStorage } from './localstorage';

export const buildCsatSurveyUrl = () => {
  const token = getStorage('token');
  if (!token) throw new Error('กรุณาเข้าสู่ระบบก่อนประเมิน');

  const oneId = String(decodeJwt(token)?.ONE_ID || '').trim();
  const bizId = String(process.env.REACT_APP_BIZ_ID_CSAC || '').trim();
  const surveyUrl = process.env.REACT_APP_URL_CSAC;
  const configuredRedirect = process.env.REACT_APP_REDIRECT_URL_CSAC;

  if (!oneId) throw new Error('ไม่พบ One ID ของผู้ใช้งาน กรุณาเข้าสู่ระบบใหม่');
  if (!bizId || !surveyUrl || !configuredRedirect) {
    throw new Error('การตั้งค่าแบบประเมินยังไม่ครบถ้วน');
  }

  // Existing environments store the redirect URL percent-encoded.
  const redirect = /^https?:\/\//i.test(configuredRedirect)
    ? configuredRedirect : decodeURIComponent(configuredRedirect);
  const url = new URL(surveyUrl);
  url.searchParams.set('one_id', oneId);
  url.searchParams.set('biz_id', bizId);
  url.searchParams.set('redirect_url', redirect);
  return url.toString();
};
